import type { FaireProductEntity } from "../../entity_types/product";

export const p_x5xu8r4uqz: FaireProductEntity = {
  token: "p_x5xu8r4uqz",
  type: "product",
  name: "Women's One Size Plush Soft Cozy Shrug Cardigan",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/1f6b3cadbcd5519beb9d1d96b298d11804ebe3264ecc2b814d1550e5ae12e1b8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ee3c3c53e017cb7e3309534ce1cd485530cf765254e39485adb20aedda14cc96.png",
    "https://cdn.faire.com/fastly/a325ab69fc0aa759b1b732b16e5e9d8fdc8c2a471731c72bd6fc2b4cbc7cd66f.png",
    "https://cdn.faire.com/fastly/de26486146c3fb4685f09f47232d069a51972577b5e8b67b9a6ac844741d19cd.jpeg",
    "https://cdn.faire.com/fastly/abbf6a38c44cd609f4fcbb06d56381d8b67fe1277d32d73073b9866dcbc9269c.jpeg",
    "https://cdn.faire.com/fastly/90cae9483c678e600f7aa2ad63af52c1e15a22fb672e28c38e86b61124dd2320.png",
    "https://cdn.faire.com/fastly/84d372e15fc209602efb8546cdb6326c4038ade3171dd8602bbc186cdd1cbae2.jpeg",
    "https://cdn.faire.com/fastly/b86709e44a3860fcc61bf5e4eb409cf9600099c221dd3e7296ec23fb43100579.png",
    "https://cdn.faire.com/fastly/3989f8b06b6ade6be1c91460b637c25ae3b63413bfa29d1c7f1d0ee42f510fc6.jpeg",
    "https://cdn.faire.com/fastly/b29860ddcfdcfe4bae0cf728af49a6f5b1cc1d4f753b597ca8dbf6daa63a806f.jpeg",
    "https://cdn.faire.com/fastly/c963f543faf299a18cdfcfc1d334723cf991f151c6cc6bc19ab78bf7659d13cc.png"
  ],
  priceDollars: 60,
  description: "Introducing the Solid Marshmallow Shrug – an effortless piece that goes with everything. Designed to be one-size-fits-all, this oversized shrug offers a lightweight layer of warmth without the bulk. The cocoon cut and finished lapel come together in a flattering silhouette that gracefully wraps around your figure. \n\nIn our ultra-soft Marshmallow fabric, you’ll feel like you’re on cloud nine whenever you put it on. Wear it for moments when you need a little coverage, whether you’re throwing it on for a video meeting or seeking solace from the chill when your kids have commandeered all the blankets. \n\nFeatures\n●\tOne-size-fits-all shrug\n●\tCocoon cut",
  tags: [],
  msrpDollars: 119,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:08.205Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
